// @flow
import React from 'react';
import styler from 'react-styling';
import { Modal, Button, ListGroup, ListGroupItem, Row, Col } from 'react-bootstrap/lib';
import { Tags, DraggableModal } from '../index';
import { getLocalDateFormat } from '../../libs/Time';

const style = styler `
  Body
    padding: 0
  Header
    background-color: #0A152D
    color: #FFF
    padding: 15px 20px
    border-radius: 8px 8px 0 0
  Title
    font-size: 20px
  List
    padding: 20px
    border: 0
    border-bottom: 1px solid #D3D3D3
    margin-bottom: 0
  Specs
    text-align: right
    color: #666
  Clock
    margin-right: 5px
  Maps
    margin-left: 10px
    color: #497BEB
    transition: 0.25s ease-in-out
    -webkit-transition: 0.25s ease-in-out
  Footer
    background-color: #FFF
`;

type Props = {
  show: boolean,
  close: any,
  languagedata: Object,
  event: Object,
};

const EventModal = (props: Props) => {
  const dateFormat = getLocalDateFormat();
  const lang = props.languagedata;
  const { event } = props;
  return (
    <Modal dialogComponentClass={DraggableModal} enforceFocus={false} backdrop="static" dialogClassName="draggable-modal" show={props.show} onHide={props.close}>
      <Modal.Header closeButton style={style.Header}>
        <Modal.Title style={style.Title}>{event.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={style.Body}>

        <ListGroup style={{ marginBottom: '0px' }}>
          {event.allDay ? (
            <ListGroupItem style={style.List}>
              <Row>
                <Col xs={3} />
                <Col xs={9}><b>{lang.all_day_event}</b></Col>
              </Row>
            </ListGroupItem>
          ) : (
            <div>
              <ListGroupItem style={style.List}>
                <Row>
                  <Col xs={3} style={style.Specs}>{lang.start}:</Col>
                  <Col xs={9}> <i className="fa fa-clock-o fa-lg" style={style.Clock} /> {event.start.format('LT')}, {event.start.format(dateFormat)} </Col>
                </Row>
              </ListGroupItem>
              <ListGroupItem style={style.List}>
                <Row>
                  <Col xs={3} style={style.Specs}>{lang.end}:</Col>
                  <Col xs={9}> <i className="fa fa-clock-o fa-lg" style={style.Clock} /> {event.end.format('LT')}, {event.end.format(dateFormat)}</Col>
                </Row>
              </ListGroupItem>
            </div>
          )}
          <ListGroupItem style={style.List}>
            <Row>
              <Col xs={3} style={style.Specs}>{lang.location}:</Col>
              <Col xs={6}>{event.location.displayName}</Col>
              {event.location != null && event.location.displayName &&
                <Col xs={3}><i className="fa fa-map-marker" aria-hidden="true" /><a href={`https://maps.google.com/?q=${event.location.displayName}`} target="_blank" rel="noopener noreferrer" style={style.Maps}>Google maps</a></Col>
              }
            </Row>
          </ListGroupItem>
          <ListGroupItem style={style.List}>
            <Row>
              <Col xs={3} style={style.Specs}>{lang.chair}:</Col>
              <Col xs={9}>{event.chair}</Col>
            </Row>
          </ListGroupItem>
          <ListGroupItem style={style.List}>
            <Row>
              <Col xs={3} style={style.Specs}>{lang.required}:</Col>
              <Col xs={9}><Tags tags={event.required} /></Col>
            </Row>
          </ListGroupItem>
          <ListGroupItem style={style.List}>
            <Row>
              <Col xs={3} style={style.Specs}>{lang.optional}:</Col>
              <Col xs={9}><Tags tags={event.optional} /></Col>
            </Row>
          </ListGroupItem>
          {
            event.body !== null ? (
              <ListGroupItem>
                <Row>
                  <Col xs={9} xsOffset={3}>
                    <div dangerouslySetInnerHTML={{ __html: event.body }} />
                  </Col>
                </Row>
              </ListGroupItem>
            ) : null
          }
        </ListGroup>
      </Modal.Body>
      <Modal.Footer style={style.Footer}>
        <Button onClick={props.close}>{lang.close}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EventModal;



// WEBPACK FOOTER //
// ./src/js/Components/Scheduler/EventModal.js